var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-viewer"},[_c('img',{attrs:{"src":_vm.path},on:{"click":_vm.photoClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }